import $ from 'jquery';
import fitvids from 'fitvids';
import debounce from 'just-debounce';
import ProductMenu from '../snippets/ProductMenu';
import Layout from '../Layout';

export default class ProductQuickshop {
  constructor($parent, $el, postMessage) {
    this.$parent = $parent;
    this.$el = $el;
    this.postMessage = postMessage;
    this.$featuredImage = $('[data-product-image-featured]', this.$el);
    this.$imageThumbs = $('[data-product-image-thumb]', this.$el);
    this.$imageThumbsSlide = $('[data-product-quickshop-image-thumbnails-slide]', this.$el);
    this.loaded = false;

    try {
      this.data = JSON.parse($('[data-quickshop-data]', this.$el).text());
    } catch(error) {
      console.warn(`Quickshop: invalid quickshop data found. ${error.message}`);
      return;
    }

    this._bindEvents();
  }

  _init() {
    this.$parent.append(this.$el);
    this.productMenu = new ProductMenu(this.$el, this.data, this.postMessage, true);
    fitvids();
    this.loaded = true;
  }

  _bindEvents() {
    $('[data-product-item-image]', this.$parent).on('click.product-quickshop', (event) => {
      // Minimum height is 500 pixels and must be desktop
      if (!Layout.isBreakpoint('L') || window.innerHeight < 500) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      this._open();
    });

    $('[data-quickshop-container]', this.$el).on('click.product-quickshop', (event) => {
      event.stopPropagation();
    });
  }

  _unbindEvents() {
    $('[data-product-item-image]', this.$parent).off('click.product-quickshop');
    $('[data-quickshop-container]', this.$el).off('click.product-quickshop');
  }

  _bindOnOpen() {
    $('[data-product-quickshop-button-dismiss]', this.$el).on('click.product-quickshop', () => {
      this._close();
    });

    this.$el.on('click.product-quickshop', () => {
      this._close();
    });

    $(document).on('keyup.product-quickshop', (event) => {
      if (event.keyCode == 27) {
        this._close();
      }
    });

    $('[data-product-quickshop-image-thumbnails-button-up]', this.$el).on(
      'click.product-quickshop',
      () => this._scrollToImage('up')
    );

    $('[data-product-quickshop-image-thumbnails-button-down]', this.$el).on(
      'click.product-quickshop',
      () => this._scrollToImage('down')
    );

    $(window).on('product-variant-switch.product-quickshop', debounce((event, data) => this._switchVariant(event, data), 250));
    this.$imageThumbs.on('click.product-quickshop', (event) => {
      const $image = $(event.currentTarget);
      this._switchImage($image);
    });

    $(window).on('resize.product-quickshop', () => this._close());
  }

  _unbindOnOpen() {
    $('[data-product-quickshop-button-dismiss]', this.$el).off('click.product-quickshop');
    this.$el.off('click.product-quickshop');
    $(document).off('keyup.product-quickshop');
    $(window).off('product-variant-switch.product-quickshop');
    this.$imageThumbs.off('click.product-quickshop');
    $(window).off('resize.product-quickshop');
  }

  _scrollToImage(direction) {
    const imageSlideTop = this.$imageThumbsSlide[0].getBoundingClientRect().top;
    let closest = direction == 'up' ? -Infinity : Infinity;
    let closestThumb = null;

    for (const imageThumb of this.$imageThumbs) {
      const top = imageThumb.getBoundingClientRect().top;
      const bottom = imageThumb.getBoundingClientRect().bottom;

      if (
        (direction == 'up' && top <= imageSlideTop && top >= closest) ||
        (direction == 'down' && bottom >= imageSlideTop && bottom <= closest)
      ) {
        closest = direction == 'up'
          ? top
          : bottom;
        closestThumb = imageThumb;
      }
    }

    const thumbIndex = this.$imageThumbs.index($(closestThumb));

    if (direction == 'up') {
      closestThumb = this.$imageThumbs.get(Math.max(thumbIndex - 1, 0));
    } else if (direction == 'down') {
      closestThumb = this.$imageThumbs.get(Math.min(thumbIndex + 1, this.$imageThumbs.length - 1));
    }

    if (closestThumb != undefined) {
      this.$imageThumbsSlide.animate({
        scrollTop: closestThumb.offsetTop - 15
      }, { queue: false, duration: 500 });
    }
  }

  _open() {
    if (!this.loaded) {
      this._init();
    }

    this._bindOnOpen();
    this.$el.revealer('show');
  }

  _close() {
    this._unbindOnOpen();
    this.$el.revealer('hide');
  }

  _switchVariant(event, data) {
    const variant = data.variant;
    const firstLoad = data.firstLoad;

    if (firstLoad || !variant.featured_image) {
      return;
    }

    const $productImage = $(`[data-product-image-id="${variant.featured_image.id}"]`, this.$imageThumbsSlide);

    if (!$productImage.length) {
      return;
    }

    this._switchImage($productImage);
  }

  _switchImage($image) {
    const alt = $image.attr('alt');
    const src = $image.data('src');
    const srcset = $image.data('srcset');

    this.$featuredImage.attr('alt', alt);
    this.$featuredImage.attr('src', src);
    this.$featuredImage.attr('srcset', srcset);

    this.$imageThumbs.each((index, el) => {
      $(el).parent().removeClass('product-quickshop-image-thumbnail-selected');
    });

    $image.parent().addClass('product-quickshop-image-thumbnail-selected');
  }

  unload() {
    if (this.productMenu) {
      this.productMenu.unload();
    }

    this._unbindOnOpen();
    this._unbindEvents();
  }
}
